import { useMemo } from 'react'

import { Game } from '../../game'
import { useFreeLiveEventsGamesSetting } from '../../settings'
import { TrackedGame } from '../types/TrackedGame'

/**
 * Hook to get free live events games as Game[] array
 * Converts game IDs from setting to Game objects using provided tracked games data
 * @param trackedGames - Array of tracked games to map IDs to Game objects
 * @returns Array of Game objects for free live events games, or undefined if no games configured
 */
export const useFreeLiveEventsGamesArray = (trackedGames: TrackedGame[] | undefined): Game[] | undefined => {
  const freeLiveEventsGamesSetting = useFreeLiveEventsGamesSetting()

  return useMemo(() => {
    const gameIds = freeLiveEventsGamesSetting.data?.data?.free_live_events_games as string[] | undefined
    if (!gameIds || !Array.isArray(gameIds) || gameIds.length === 0) {
      return undefined
    }
    if (!trackedGames) {
      return undefined
    }

    // Map game IDs to Game objects from tracked games, preserving order of gameIds from setting
    return gameIds.map((id) => trackedGames.find((tg) => tg.game.id === id)?.game).filter((game): game is Game => game != null)
  }, [freeLiveEventsGamesSetting.data?.data?.free_live_events_games, trackedGames])
}
